import React, { Component } from "react";
import EditIcon from "@material-ui/icons/Edit";
import { connect } from "react-redux";
import { SwipeableDrawer, Drawer } from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

function isMobileOrTablet() {
  return /(android|iphone|ipad|mobile)/i.test(navigator.userAgent);
}

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class ShareCartDrawer extends Component {
  state = {
    snackOpen: false,
  };
  render() {
    const { language, settings, open, abandonedCartID } = this.props;

    const cartURL = window.location.origin + "/?cart=" + abandonedCartID;
    const copyToClipboard = () => {
      navigator.clipboard.writeText(cartURL);
    };
    const handleClose = (event, reason) => {
      if (reason === "clickaway") {
        return;
      }

      this.setState({ snackOpen: false });
    };

    const isCheckout = window.location.href.endsWith("confirmation");
    return (
      <Drawer
        anchor="bottom"
        classes={{
          paperAnchorBottom: language == "arabic" ? "left-auto" : "",
        }}
        open={open}
        onClose={() => {
          this.setState({ snackOpen: false });
          this.props.close();
        }}
        PaperProps={{
          style: { minHeight: 100, height: "auto", width: "100%" },
          className: "text-center",
        }}
        onBackdropClick={() => {
          this.setState({ snackOpen: false });
          this.props.close();
        }}
      >
        <div
          style={{
            height: 200,
            textAlign: language === "arabic" ? "right" : "left",
            position: "relative",
            padding: 5,
            direction: language === "arabic" ? "rtl" : "ltr",
          }}
        >
          <div className="p-3">
            <p style={{ fontWeight: "bold", marginBottom: 10, fontSize: 18 }}>
              {!isCheckout
                ? language === "arabic"
                  ? "مشاركة السلة"
                  : "Share cart"
                : language === "arabic"
                ? "ارسال الطلب"
                : "Send checkout"}
            </p>
            <p style={{ marginBottom: 25, fontSize: 16 }}>
              {!isCheckout
                ? language === "arabic"
                  ? "شارك هذه السلة مع اصدقائك ليضيفوا منتجاتهم اليها ويقوموا بإتمام الطلب بسرعة"
                  : "Share this cart with a friend so they can just add their details and they can checkout fast."
                : language === "arabic"
                ? "ارسل هذا الطلب الى صديق لمراجعة الطلب والدفع بسرعة"
                : "Send this checkout to a friend so that they can review and checkout fast."}
            </p>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "49.3% 49.3%",
                columnGap: 7,
                width: "100%",
              }}
            >
              <div
                style={{
                  border: "1px solid " + this.props.themeColor,
                  borderRadius: 5,
                  textAlign: "center",
                  height: 50,
                  display: "grid",
                  justifyContent: "center",
                  alignContent: "center",
                  color: this.props.themeColor,
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
                onClick={() => {
                  this.setState({ snackOpen: true });
                  copyToClipboard();
                }}
              >
                {language === "arabic" ? "نسخ الرابط" : "Copy Link"}
              </div>
              <div
                style={{
                  border: "1px solid #23D366",
                  background: "#23D366",
                  borderRadius: 5,
                  color: "white",
                  textAlign: "center",
                  height: 50,
                  display: "grid",
                  justifyContent: "center",
                  alignContent: "center",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
                onClick={() =>
                  window.open(
                    "https://" +
                      (isMobileOrTablet() ? "api" : "web") +
                      ".whatsapp.com/send?text=" +
                      cartURL,
                    "_blank"
                  )
                }
              >
                {language === "arabic" ? "ارسال واتساب" : "Send WhatsApp"}
              </div>
            </div>
          </div>
        </div>

        <Snackbar
          open={this.state.snackOpen}
          autoHideDuration={3000}
          onClose={handleClose}
          classes={{ anchorOriginBottomCenter: "snackbar-bottom-70" }}
        >
          <Alert onClose={handleClose} severity="success">
            {language == "english"
              ? "Cart link copied successfully!"
              : "تم نسخ رابط السلة"}
          </Alert>
        </Snackbar>
      </Drawer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
    abandonedCartID: state.abandonedCart.id,
    themeColor: state.store.store.settings.dark || "#0099cc",
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareCartDrawer);
